import styled, { css } from 'styled-components';
import { variants } from 'style/theme';

const BLUEWOOD = '#273C49';
const BLUEWOOD_600 = '#1F303A';

const alertVariants = variants('variant', {
  error: css`
    --alert-color: #eb5a47;
    --alert-background: #fbdeda;
  `,
  success: css`
    --alert-color: #71c13a;
    --alert-background: #e3f3d8;
  `,
  warning: css`
    --alert-color: #edad68;
    --alert-background: #fbedde;
  `,
  information: css`
    --alert-color: #50aeeb;
    --alert-background: #e3f2fc;
  `
});

export const TitledContainer = styled.div`
  ${alertVariants};

  display: flex;
  width: 100%;
  gap: 8px;
  padding: 14px 14px 14px 10px;
  border: 1.5px solid var(--alert-color);
  border-radius: 16px;
  background-color: var(--alert-background);
  color: ${BLUEWOOD};
  font-size: 0.85rem;
  line-height: 1.25rem;

  & > svg {
    flex-shrink: 0;
    color: var(--alert-color);
  }
`;

export const Container = styled.div`
  ${alertVariants};

  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 4px;
  padding: 10px;
  border: 1.5px solid var(--alert-color);
  border-radius: 16px;
  background-color: var(--alert-background);
  color: ${BLUEWOOD};
  font-size: 0.85rem;
  line-height: 1.25rem;

  & > svg {
    color: var(--alert-color);
  }
`;

export const Heading = styled.h5`
  margin: 0;
  font-size: inherit;
  line-height: inherit;
  font-weight: ${({ $medium }) => ($medium ? 500 : 'inherit')};
  color: inherit;
`;

export const TitledBody = styled.div`
  margin-top: 4px;

  p {
    margin: 0;
  }
`;

export const TitledAction = styled.div`
  margin-top: 12px;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  margin-left: 4px;
`;

const buttonBase = css`
  position: relative;
  isolation: isolate;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: calc(0.5rem - 1.5px) calc(0.75rem - 1.5px);
  border: 1.5px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: ${BLUEWOOD};
  font: inherit;
  font-size: 0.85rem;
  line-height: 1.25rem;
  font-weight: 500;
  cursor: pointer;
  transition: transform 150ms, background-color 150ms;

  &:hover {
    background-color: rgba(39, 60, 73, 0.05);
  }

  &:active {
    transform: scale(0.97);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${BLUEWOOD};
    outline-offset: 2px;
  }

  & > svg {
    width: 20px;
    height: 20px;
  }
`;

export const OutlineButton = styled.button`
  ${buttonBase};
  border-color: ${BLUEWOOD_600};
`;

export const GhostButton = styled.button`
  ${buttonBase};
  margin: -4px 0 -4px -4px;
  padding: 2px 4px;
  border-radius: 8px;

  &:focus-visible {
    outline-offset: 0;
  }
`;

export const CloseButton = styled.button`
  ${buttonBase};
  flex-shrink: 0;
  padding: 2px;
  border-radius: 8px;
  margin: ${({ $titled }) => ($titled ? '-4px -4px auto auto' : '-4px 0 -8px auto')};

  &:focus-visible {
    outline-offset: 0;
  }
`;
